import { createFileRoute, redirect } from '@tanstack/react-router';

import { canManageOrganizationMembers } from '@/features/organizations/permissions';
import { requireOrganizationRoleRoute } from '@/lib/router-guards';

export const Route = createFileRoute('/_app/members')({
    beforeLoad: () => {
        requireOrganizationRoleRoute(canManageOrganizationMembers);
        throw redirect({ to: '/organizations', hash: 'members' as never });
    },
    component: MembersRedirectPage
});

function MembersRedirectPage() {
    return null;
}
